// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".address[data-v-42c0be87]{font-size:.9em;font-weight:400}", "",{"version":3,"sources":["webpack://./resources/js/Components/Common/OrganizationSelector.vue"],"names":[],"mappings":"AAAA,0BAAyB,cAAA,CAAhB,eAGT","sourcesContent":[".address{font-weight:400;font-size:.9em}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
